<template>
  <b-modal
    ref="modal"
    :visible="true"
    static
    lazy
    centered
    no-fade
    :title="title"
    hide-footer
    @hidden="onHidden"
  >
    <form @submit.prevent="submit" novalidate>
      <div class="form-group">
        <label class="small font-weight-bold text-muted" for="pf-name">Название <span class="text-danger">*</span></label>
        <input id="pf-name" v-model="form.name" type="text" class="form-control form-control-sm" :disabled="busy" maxlength="255">
      </div>
      <div class="form-group">
        <label class="small font-weight-bold text-muted" for="pf-address">Адрес</label>
        <input id="pf-address" v-model="form.address" type="text" class="form-control form-control-sm" :disabled="busy">
      </div>
      <div class="form-row align-items-end">
        <div class="form-group col-4">
          <label class="small font-weight-bold text-muted" for="pf-lat">Широта <span class="text-danger">*</span></label>
          <input id="pf-lat" v-model="form.latitude" type="number" step="0.000001" min="-90" max="90" class="form-control form-control-sm" :disabled="busy">
        </div>
        <div class="form-group col-4">
          <label class="small font-weight-bold text-muted" for="pf-lng">Долгота <span class="text-danger">*</span></label>
          <input id="pf-lng" v-model="form.longitude" type="number" step="0.000001" min="-180" max="180" class="form-control form-control-sm" :disabled="busy">
        </div>
        <div class="form-group col-4">
          <button type="button" class="btn btn-sm btn-outline-secondary btn-block pfm__pick" :disabled="busy" @click="$emit('pick-on-map', { ...form })">Указать на карте</button>
        </div>
      </div>
      <div class="form-group">
        <label class="small font-weight-bold text-muted" for="pf-group">Группа</label>
        <select id="pf-group" v-model="form.group_id" class="form-control form-control-sm pfm__group" :disabled="busy">
          <option value="">Без группы</option>
          <option v-for="g in groups" :key="g.id" :value="g.id">{{ g.title || '—' }}</option>
        </select>
      </div>
      <div class="form-group">
        <label class="small font-weight-bold text-muted" for="pf-desc">Описание</label>
        <textarea id="pf-desc" v-model="form.description" rows="2" class="form-control form-control-sm" :disabled="busy"></textarea>
      </div>
      <ul v-if="errors.length" class="alert alert-danger py-2 pl-4 mb-3" role="alert">
        <li v-for="(e, i) in errors" :key="i">{{ e }}</li>
      </ul>
      <div class="d-flex justify-content-between">
        <button type="button" class="btn btn-secondary btn-sm pfm__cancel" :disabled="busy" @click="hideModal">Отмена</button>
        <button type="submit" class="btn btn-success btn-sm pfm__submit" :disabled="busy">Сохранить</button>
      </div>
    </form>
  </b-modal>
</template>

<script>
import * as api from '@/components/management/dispatcher/api';
import { hasValidCoords } from '@/components/management/dispatcher/objectState';
import { notifySuccess, notifyError } from '@/components/management/dispatcher/notify';
import modalCloseMixin from './modalCloseMixin';

const str = (v) => (v === null || v === undefined ? '' : String(v));

export function emptyPointForm() {
  return {
    name: '', address: '', description: '', latitude: '', longitude: '', group_id: '',
  };
}

export function pointFormFromPoint(point) {
  const p = point || {};
  return {
    name: str(p.name),
    address: str(p.address),
    description: str(p.description),
    latitude: str(p.latitude),
    longitude: str(p.longitude),
    group_id: p.group_id === null || p.group_id === undefined ? '' : p.group_id,
  };
}

export function buildPointPayload(form, id) {
  const payload = {
    name: str(form.name).trim(),
    address: str(form.address).trim(),
    description: str(form.description).trim(),
    latitude: Number(form.latitude),
    longitude: Number(form.longitude),
    mark_data: 'rhombus',
    custom: 1,
    group_id: form.group_id === '' || form.group_id === null || form.group_id === undefined ? null : Number(form.group_id),
  };
  if (id !== undefined && id !== null) payload.id = id;
  return payload;
}

export function validatePointForm(form) {
  const errors = [];
  if (!str(form.name).trim()) errors.push('Укажите название точки.');
  if (!hasValidCoords(form)) errors.push('Укажите корректные координаты (широта −90…90, долгота −180…180).');
  return errors;
}

export default {
  name: 'PointFormModal',
  mixins: [modalCloseMixin],
  props: {
    point: { type: Object, default: null },
    groups: { type: Array, default: () => [] },
    initialForm: { type: Object, default: null },
  },
  data() {
    let form;
    if (this.initialForm) form = { ...this.initialForm };
    else if (this.point) form = pointFormFromPoint(this.point);
    else form = emptyPointForm();
    return { form, errors: [], busy: false };
  },
  computed: {
    title() { return this.point ? 'Изменение точки' : 'Новая дополнительная точка'; },
  },
  methods: {
    async submit() {
      if (this.busy) return;
      this.errors = validatePointForm(this.form);
      if (this.errors.length) return;
      this.busy = true;
      try {
        const payload = buildPointPayload(this.form, this.point ? this.point.id : undefined);
        const saved = this.point ? await api.updatePoint(payload) : await api.createPoint(payload);
        notifySuccess(this, 'Точка сохранена');
        this.$emit('saved', saved);
        this.hideModal();
      } catch (e) {
        notifyError(this, e);
      } finally {
        this.busy = false;
      }
    },
  },
};
</script>
